import * as React from 'react';
import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import { Controller } from 'react-hook-form';

import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { FormHelperText } from '@mui/material';


import { SelectTypeInput } from '../../DoctorMangement/EditDoctor/SelectTypeInput';
import { checkBoxWithBlueBorder } from "../../DoctorMangement/StyledComponent"
import { TextTypeInput } from '../../DoctorMangement/EditDoctor/TextTypeInput';
import { getEntityList, getEntityNameMapping, getEntityIdMapping, rolesArray , getRolesIdForSelectedRoles} from '../Helper/utils';
import { ToastEmitter } from '../../DoctorMangement/ToastEmitter';
import { MultipleSelectTypeInput } from '../components/MultiSelectInput'
import { TableStyle } from "../../DoctorMangement/StyledComponent"
import { BackdropLoader } from '../../DoctorMangement/BackdropLoader';
import { CommsSelectCheckBox } from "../../DoctorMangement/EditDoctor/CommsSelectCheckBox"
import { checkBoxCustomStyle } from "../../DoctorMangement/StyledComponent"
import { ACCESS_LEVEL_ARRAY, FORM_NAMES_KEY, Access_Level  } from '../constant';
import { UpdateSPOC, CreateSPOC } from '../Helper/API';
import {  getUserDetails } from '../../DoctorMangement/Helper/utils'
import { logEventToAnalyticsPlatform, fetchUserDetailsAndSetUserForAnalytics } from '../../../helper/events';
import {EVENTS } from '../../DoctorMangement/events_Constant'
import {getDepartmentsFromRoles, getDepartments } from '../../../helper/utils';
export const SPOCProfileForm = ({ setSPOCProfileDetails, SPOCProfileDetails }) => {
    const {
        control,
        handleSubmit,
        formState: { errors, isDirty, isValid },
        reset,
        trigger,
        setError,
        getValues,
        setValue,
        watch,
        register,
        clearErrors
    } = useForm({
        mode: 'onBlur',
    });

    const [whatsAppNumberCopy, setWhatsAppNumberCopy] = useState(false);
    const [OFCselectedDepartment, setOFCselectedDepartment] = useState([]);
    const [labSelectedDepartment, setLabSelectedDepartment] = useState([]);
    const [columnCheck, setColumnCheck] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get('id');
    const [isLoading, setIsLoading] = useState(false);

    const SPOCUserDetails = SPOCProfileDetails?.user[0] || {};
    const user_details = getUserDetails();
    const isParentProvider = user_details?.parentProvider?.isParent;;
    const watchOPDActive = watch(FORM_NAMES_KEY.OPD_ACTIVE)
    const watchLabActive = watch(FORM_NAMES_KEY.LABS_ACTIVE);
    const [commsOptionsSPOC, setCommsOptionsSPOC] = useState({});
    const [commsOptionsDoctor, setCommsOptionsDoctor] = useState({});
    const [commsOptionsOrder, setCommsOptionsOrder] = useState({});
    const watchComms = watch('comms');
    const [commsPrefEnabled , setCommsPrefEnabled] = useState(false);
    const [OFCDepartment, setOFCDepartment] = useState([]);
    const [labDepartment, setLabDepartment] = useState([]);

    const [commsPrefChanged, setCommsPrefChanged] = useState(false)


    useEffect(() => {
        getDepartments(setOFCDepartment, setLabDepartment);
    },[])
    const checkColumnsExisting = () => {
        if (getValues('providerName').trim() == '' || getValues('userName') == '') {
            return true;
        }
        else {
            return false;
        }
    }

    useEffect(() => {

        const userData = SPOCUserDetails;
        const userProperties = userData?.properties;
        const userRoles = userData?.roles
        const {labSelectedDepartment, OFCselectedDepartment} = getDepartmentsFromRoles(userRoles);

      
        setLabSelectedDepartment(labSelectedDepartment);
        setOFCselectedDepartment(OFCselectedDepartment);

        //Services 
        const isLabsSeclected = userRoles?.filter((item) => {
            const itemRoleNameSplit = item.roleName.split('/*/');
            if(itemRoleNameSplit.length > 1 && itemRoleNameSplit[1].toLowerCase()=='services'){
            const itemRoleName = itemRoleNameSplit[0].toLowerCase();
            return itemRoleName === 'labs';
            }
        }).length > 0 ? true : false;

        const isConsultsSelected = userRoles?.filter((item) => {
            const itemRoleNameSplit = item.roleName.split('/*/');
            if(itemRoleNameSplit.length > 1 && itemRoleNameSplit[1].toLowerCase() =='services'){
            const itemRoleName = itemRoleNameSplit[0].toLowerCase();
            return itemRoleName === 'ofc';
            }
        }).length > 0 ? true : false;
        
        const isVisionSelected = userRoles?.filter((item) => {
            const itemRoleNameSplit = item.roleName.split('/*/');
            if(itemRoleNameSplit.length > 1 && itemRoleNameSplit[1].toLowerCase() =='services'){
            const itemRoleName = itemRoleNameSplit[0].toLowerCase();
            return itemRoleName === 'vision';
            }
        }).length > 0 ? true : false;
        
        const entityNameMapping =  getEntityIdMapping();
        reset({
            firstName: userData?.firstName || '',
            lastName: userData?.lastName || '',
            email: userData?.emailId || '',
            phoneNumber: userData?.mobileNo || '',
            whatsAppNumber: userProperties?.WhatsAppNumber || '',
            OFCspecicality: OFCselectedDepartment || [],
            labsSpecicality: labSelectedDepartment || [],
            providerName: entityNameMapping[userData?.entityId] || '',
            userName: userData?.userName || '',
        })

        setValue(FORM_NAMES_KEY.LABS_ACTIVE, isLabsSeclected, { shouldValidate: true });
        setValue(FORM_NAMES_KEY.OPD_ACTIVE, isConsultsSelected, { shouldValidate: true });
        setValue(FORM_NAMES_KEY.VISION_ACTIVE, isVisionSelected, { shouldValidate: true });
        setValue(FORM_NAMES_KEY.SELCTED_SERVICES, isLabsSeclected || isConsultsSelected || isVisionSelected, { shouldValidate: true });

        //AccessLevel 
        let accessLevel;
        for (let i = 0; i < userRoles?.length; i++) {
            const roleName = userRoles[i]?.roleName
            const splitName = roleName.split('/*/');
            if (splitName.length > 1) {
                accessLevel = splitName[1].toLowerCase();
                if(ACCESS_LEVEL_ARRAY.includes(accessLevel))
                break;
            }
        }
        
        setValue(FORM_NAMES_KEY.ACCESS_LEVEL, accessLevel)

        //SPOC updates

        //convert properties to boolean value 
        const convertToBoolean = (obj) => {
            for (let key in obj) {
                if (obj[key] === "true") {
                    obj[key] = true;
                } else if (obj[key] === "false") {
                    obj[key] = false;
                }
            }
            return obj;
        };

        convertToBoolean(userProperties);

        if ( userProperties && ( 
            userProperties[FORM_NAMES_KEY.SPOC_UPDATE_EMAIL] || 
            userProperties[FORM_NAMES_KEY.SPOC_UPDATE_SMS] || 
            userProperties[FORM_NAMES_KEY.SPOC_UPDATE_WHATSAPP])) {
            setValue(FORM_NAMES_KEY.SPOC, true)
            setValue(FORM_NAMES_KEY.SPOC_UPDATE_EMAIL, userProperties[FORM_NAMES_KEY.SPOC_UPDATE_EMAIL]);
            setValue(FORM_NAMES_KEY.SPOC_UPDATE_SMS, userProperties[FORM_NAMES_KEY.SPOC_UPDATE_SMS]);
            setValue(FORM_NAMES_KEY.SPOC_UPDATE_WHATSAPP, userProperties[FORM_NAMES_KEY.SPOC_UPDATE_WHATSAPP])
            setValue(FORM_NAMES_KEY.COMMSELECTION, 'true');
            setCommsPrefEnabled(true);

        }

        //Doctor Managements 
        if (userProperties && ( 
            userProperties[FORM_NAMES_KEY.DOCTOR_UPDATE_WHATSAPP] || 
            userProperties[FORM_NAMES_KEY.DOCTOR_UPDATE_EMAIL] || 
            userProperties[FORM_NAMES_KEY.DOCTOR_UPDATE_SMS])) {
            setValue(FORM_NAMES_KEY.DOCTOR, true)
            setValue(FORM_NAMES_KEY.DOCTOR_UPDATE_EMAIL, userProperties[FORM_NAMES_KEY.DOCTOR_UPDATE_EMAIL]);
            setValue(FORM_NAMES_KEY.DOCTOR_UPDATE_SMS, userProperties[FORM_NAMES_KEY.DOCTOR_UPDATE_SMS]);
            setValue(FORM_NAMES_KEY.DOCTOR_UPDATE_WHATSAPP, userProperties[FORM_NAMES_KEY.DOCTOR_UPDATE_WHATSAPP]);
            setValue(FORM_NAMES_KEY.COMMSELECTION, 'true');
            setCommsPrefEnabled(true);

        }

        if( userProperties && ( 
            userProperties[FORM_NAMES_KEY.APPOINTMENT_UPDATE_EMAIL] || 
            userProperties[FORM_NAMES_KEY.APPOINTMENT_UPDATE_SMS] || 
            userProperties[FORM_NAMES_KEY.APPOINTMENT_UPDATE_WHATSAPP])){
            setValue(FORM_NAMES_KEY.APPOINTMENT, true)
            setValue(FORM_NAMES_KEY.APPOINTMENT_UPDATE_EMAIL, userProperties[FORM_NAMES_KEY.APPOINTMENT_UPDATE_EMAIL]);
            setValue(FORM_NAMES_KEY.APPOINTMENT_UPDATE_SMS, userProperties[FORM_NAMES_KEY.APPOINTMENT_UPDATE_SMS]);
            setValue(FORM_NAMES_KEY.APPOINTMENT_UPDATE_WHATSAPP, userProperties[FORM_NAMES_KEY.APPOINTMENT_UPDATE_WHATSAPP]);
            setValue(FORM_NAMES_KEY.COMMSELECTION, 'true');
            setCommsPrefEnabled(true);
        }

        setValue('comms', true)

        const disable = checkColumnsExisting();
        setColumnCheck(!disable);

    }, [SPOCProfileDetails]);

    const transformUserData = async (inputData, status) => {
        try{
            const userRoles = await getRolesIdForSelectedRoles(inputData);
            const userData= SPOCProfileDetails?.user.length>0 ? SPOCProfileDetails.user[0]: {};
            return {
                userName: userData?.userName || inputData?.email,
                userId: userData?.userId || '',
                applicationId: '10007',
                firstName: inputData.firstName,
                lastName: inputData.lastName,
                email: inputData.email,
                phoneNumber: inputData.phoneNumber,
                providerMasterEntityId: userData.entityId || inputData.entityId,
                entityId:  userData.entityId || inputData.entityId, //this enetity id is needed to check for valid entity access is available or not 
                tau_isMobileVerified: true,
                tau_IsEmailVerified: true,
                autoGenerateUsername: true,
                userRoles: userRoles,
                password:"12345678",
                whatsappno: inputData.whatsAppNumber,
                ignoreAliasConfig: false,
                getSpocUpdateEmail: commsOptionsSPOC.Email,
                getSpocUpdateSMS: commsOptionsSPOC.SMS,
                getSpocUpdateWhatsapp: commsOptionsSPOC.WhatsApp,
                getDoctorUpdateEmail: commsOptionsDoctor.Email,
                getDoctorUpdateSMS: commsOptionsDoctor.SMS,
                getDoctorUpdateWhatsapp: commsOptionsDoctor.WhatsApp,
                getOrderUpdateEmail: commsOptionsOrder.Email,
                getOrderUpdateSMS: commsOptionsOrder.SMS,
                getOrderUpdateWhatsapp: commsOptionsOrder.WhatsApp,
    
            };
        }
        catch(e){
            ToastEmitter('Something went wrong Please Try Again', 'error');
        }
    };

 
    const submitAndProceed = async () => {
        const entityNameMapping = getEntityNameMapping();
        const entityName = getValues('providerName');
        const entityId = parseInt(entityNameMapping[entityName]);
        setValue('entityId', entityId)
        const userData = getValues();
        createOrUpdateSPOC(userData);
    }

    const createOrUpdateSPOC = async (userData) => {
        try {
            setIsLoading(true);
            let resp;
            const data = await transformUserData(userData)
            if (data.userName && data.userId) {
                resp = await UpdateSPOC(data);
                    logEventToAnalyticsPlatform({
                        name: EVENTS.PC_LS_ACTION.name,
                        payload: {
                            tab_name: EVENTS.TAB_NAME.ADD_SPOC,
                            filterValue: '',
                            reference_id: "" + SPOCUserDetails?.userId,
                            reference_provider_id: "" + SPOCUserDetails?.entityId,
                            reference_provider_name: user_details?.entityName,
                            service_name: EVENTS.SERVICE_NAME_SPOC,
                            action: EVENTS.ACTION.SPOC_EDIT_SUBMIT,
                        },
                        schema: EVENTS.PC_LS_ACTION.schema,
                    })
            }
            else {
                resp = await CreateSPOC(data);
                logEventToAnalyticsPlatform({
                    name: EVENTS.PC_LS_ACTION.name,
                    payload: {
                        tab_name: EVENTS.TAB_NAME.ADD_SPOC,
                        filterValue: '',
                        reference_id: "",
                        reference_provider_id: "" + SPOCUserDetails?.entityId,
                        reference_provider_name: user_details?.entityName,
                        service_name: EVENTS.SERVICE_NAME_SPOC,
                        action: EVENTS.ACTION.SPOC_ADD_SUBMIT,
                    },
                    schema: EVENTS.PC_LS_ACTION.schema,
                })
            }
            if (resp?.isSuccess || resp?.success) {                
                setIsLoading(false);
                ToastEmitter('SPOC Profile Saved Successfully', 'success');
                history.push("/SPOC/SPOCManagement");
                return true;
            }
            else {
                ( resp?.response?.data?.error == 'User_Already_Present' ?
                        ToastEmitter('User Already Present', 'error') :
                        resp.response.status == 403 ?
                            ToastEmitter('You do not have permission to perform this action', 'error') :
                            ToastEmitter('Something went wrong', 'error')
                   )
                setIsLoading(false);
                return false;
            }
        }
        catch (err) {
            setIsLoading(false);
            ToastEmitter('Something went wrong Please Try Again', 'error');
            return false;
        }
    }

    const handleCopyContactNumber = (e) => {
        const checked = e.target.checked;
        setWhatsAppNumberCopy(checked);
        if (checked) {
            const contactNumber = getValues('phoneNumber');
            setValue('whatsAppNumber', contactNumber, { shouldValidate: true, shouldDirty: true });
        }
        else {
            setValue('whatsAppNumber', '', { shouldValidate: true, shouldDirty: true });
        }
    }

    useEffect(()=>{
        if(!isParentProvider) {
            setValue('providerName', user_details?.entityName)
        }
    },[])

    const toogleServiceChangeOFC = (e, name) => {
        const value = e.target.checked;
        setValue(name, value);
        if (getValues(FORM_NAMES_KEY.LABS_ACTIVE) || getValues(FORM_NAMES_KEY.OPD_ACTIVE) || getValues(FORM_NAMES_KEY.VISION_ACTIVE)) {
            setValue(FORM_NAMES_KEY.SELCTED_SERVICES, true, { shouldDirty: true, shouldValidate: true });
        }
        else {
            setValue(FORM_NAMES_KEY.SELCTED_SERVICES, null, { shouldDirty: true, shouldValidate: true });
        }

        //OFC All select
        if (getValues(name) && getValues(FORM_NAMES_KEY.OPD_ACTIVE)) {
            setOFCselectedDepartment([]);
            setValue(FORM_NAMES_KEY.OFC_SPECIALITY, []);
        }
        else {
            setOFCselectedDepartment([]);
            setValue(FORM_NAMES_KEY.OFC_SPECIALITY,[]);
        }

    }


    const toogleServiceChangeLabs = (e, name) => {
        const value = e.target.checked;
        setValue(name, value);
        if (getValues(FORM_NAMES_KEY.LABS_ACTIVE) || getValues(FORM_NAMES_KEY.OPD_ACTIVE) || getValues(FORM_NAMES_KEY.VISION_ACTIVE)) {
            setValue(FORM_NAMES_KEY.SELCTED_SERVICES, true, { shouldDirty: true, shouldValidate: true });
        }
        else {
            setValue(FORM_NAMES_KEY.SELCTED_SERVICES, null, { shouldDirty: true, shouldValidate: true });
        }

        //ALL labs Select 
        if(getValues(FORM_NAMES_KEY.LABS_ACTIVE)){
           setLabSelectedDepartment([]);
           setValue(FORM_NAMES_KEY.LAB_SPECIALITY,[]);
        }
        else {
            setLabSelectedDepartment([]);
            setValue(FORM_NAMES_KEY.LAB_SPECIALITY,[]);
        }

    }

    const toogleServiceChangeVision = (e, name) => {
        const value = e.target.checked;
        setValue(name, value);
        if (getValues(FORM_NAMES_KEY.LABS_ACTIVE) || getValues(FORM_NAMES_KEY.OPD_ACTIVE) || getValues(FORM_NAMES_KEY.VISION_ACTIVE)) {
            setValue(FORM_NAMES_KEY.SELCTED_SERVICES, true, { shouldDirty: true, shouldValidate: true });
        }
        else {
            setValue(FORM_NAMES_KEY.SELCTED_SERVICES, null, { shouldDirty: true, shouldValidate: true });
        }
    }

    const handleClose = () => {
        if(SPOCProfileDetails?.userId){
            logEventToAnalyticsPlatform({
                name: EVENTS.PC_LS_ACTION.name,
                payload: {
                    tab_name: EVENTS.TAB_NAME.ADD_SPOC,
                    filterValue: '',
                    reference_id: "" + SPOCUserDetails?.userId,
                    reference_provider_id: "" + SPOCUserDetails?.entityId,
                    reference_provider_name: user_details?.entityName,
                    service_name: EVENTS.SERVICE_NAME_SPOC,
                    action: EVENTS.ACTION.SPOC_EDIT_CLOSE,
                },
                schema: EVENTS.PC_LS_ACTION.schema,
            })
        }
        else {
            logEventToAnalyticsPlatform({
                name: EVENTS.PC_LS_ACTION.name,
                payload: {
                    tab_name: EVENTS.TAB_NAME.ADD_SPOC,
                    filterValue: '',
                    reference_id: "",
                    reference_provider_id: "" + SPOCUserDetails?.entityId,
                    reference_provider_name: user_details?.entityName,
                    service_name: EVENTS.SERVICE_NAME_SPOC,
                    action: EVENTS.ACTION.SPOC_ADD_CLOSE,
                },
                schema: EVENTS.PC_LS_ACTION.schema,
            })
        }
        history.push("/SPOC/SPOCManagement");
    }

    useEffect(() => {
        const triggerEvents = async () => {
            await fetchUserDetailsAndSetUserForAnalytics();
            logEventToAnalyticsPlatform({
                name: EVENTS.PC_SCREEN_LANDING.name,
                payload: {
                    tab_name: EVENTS.TAB_NAME_ADD_EDIT_SPOC,
                    service_type: EVENTS.SERVICE_TYPE_SPOC,
                    screenName: EVENTS.SERVICE_NAME_SPOC,
                },
                schema: EVENTS.PC_SCREEN_LANDING.schema,
            })
        }
        triggerEvents();
    }, [])

    useEffect(() => {
        //if there is any master option selected check for child else check for false then make things valid thats all 
        let isCommsSelectionValid = false;
       if(commsPrefChanged){
         //for SPOC 
         if (commsOptionsSPOC.commsType && (commsOptionsSPOC?.Email || commsOptionsSPOC?.WhatsApp || commsOptionsSPOC?.SMS)) {
            isCommsSelectionValid = true;
        }
        //for Doctor
        if (commsOptionsDoctor?.commsType && (commsOptionsDoctor?.Email || commsOptionsDoctor?.WhatsApp || commsOptionsDoctor?.SMS)) {
            isCommsSelectionValid = true;
        }
        //for Order
        if (commsOptionsOrder.commsType && (commsOptionsOrder?.Email || commsOptionsOrder?.WhatsApp || commsOptionsOrder?.SMS)) {
            isCommsSelectionValid = true;
        }

        if (!commsPrefEnabled) isCommsSelectionValid = true;

        if (!isCommsSelectionValid) {
            setError('commsSelection', { type: 'manual', message: 'Please select at least one communication option', shouldFocus: true});
            setValue('commsSelection', null, { shouldDirty: true});

        }
        else {
            clearErrors('commsSelection');
            setValue('commsSelection', true, { shouldDirty: true, shouldValidate: true });

        }
       }
    }, [commsOptionsSPOC,commsOptionsDoctor,commsOptionsOrder, commsPrefEnabled, watchComms])


    return (

        <>

            {isLoading && <BackdropLoader isLoading={isLoading} />}
            <List sx={TableStyle} className='w-[80vw] '>
                <div className='flex flex-col gap-6 '>
                    <div className=""></div>
                    {isParentProvider && <>
                        <div className="flex gap-x-32 p-4  pt-6  items-center" style={{ gap: '5rem' }}>
                            <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                                Provider Branch
                                <p className=' text-mb-red' >*</p>
                            </div>
                            <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                                <FormControl error={!!errors.providerName}>
                                    <SelectTypeInput
                                        name={'providerName'}
                                        placeholder={'Select Branch'}
                                        control={control}
                                        width={'31.6rem'}
                                        height={'2.75rem'}
                                        defaultValue=''
                                        rules={{
                                            required: "Mandatory Information",
                                        }}
                                        options={getEntityList().map((value) => ({ value: value, title: value }))} //thjis one we have to put effort
                                        columnCheck={columnCheck}
                                        errors={errors}
                                    />

                                </FormControl>
                            </div>
                        </div>
                        <Divider variant='middle' component="li" />
                    </>}

                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Name
                            <p className=' text-mb-red' >*</p>
                        </div>
                        <div className="flex flex-row " style={{ gap: '1.5rem' }}>

                            <FormControl error={!!errors.firstName}>
                                <TextTypeInput
                                    name={'firstName'}
                                    placeholder="First Name"
                                    control={control}
                                    defaultValue=""
                                    width={'15.25rem'}
                                    height={'2.75rem'}
                                    rules={{
                                        required: "Mandatory Information",
                                        validate: {
                                            isValidName: (val) => {
                                                const trimmedVal = val.trim();
                                                const validNameRegex = /^[A-Za-z\s.]+$/;

                                                if (!validNameRegex.test(trimmedVal)) {
                                                    return "Only A-Z, a-z, '.' and spaces are allowed."
                                                }

                                                if (trimmedVal.length === 0) {
                                                    return 'Name cannot be empty.';
                                                }
                                                return true;
                                            }

                                        }
                                    }}
                                    errors={errors}
                                />
                            </FormControl>

                            <FormControl error={!!errors.lastName}>
                                <TextTypeInput
                                    name={'lastName'}
                                    placeholder="Last Name"
                                    control={control}
                                    defaultValue=""
                                    width={'15.25rem'}
                                    height={'2.75rem'}
                                    rules={{
                                        required: "Mandatory Information",
                                        validate: {
                                            isValidName: (val) => {
                                                const trimmedVal = val.trim();
                                                const validNameRegex = /^[A-Za-z\s.]+$/;

                                                if (!validNameRegex.test(trimmedVal)) {
                                                    return "Only A-Z, a-z, '.' and spaces are allowed."
                                                }

                                                if (trimmedVal.length === 0) {
                                                    return 'Name cannot be empty.';
                                                }
                                                return true;
                                            }

                                        }
                                    }}
                                    errors={errors}
                                />
                            </FormControl>
                        </div>
                    </div>

                    <Divider variant='middle' component="li" />


                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Email ID
                            <p className=' text-mb-red' >*</p>
                        </div>
                        <div className="flex flex-row " style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.email}>
                                <TextTypeInput
                                    name={'email'}
                                    placeholder="Enter Your Email ID"
                                    control={control}
                                    defaultValue=""
                                    width={'31.6rem'}
                                    height={'2.75rem'}
                                    rules={{
                                        required: "Mandatory Information",
                                        validate: {
                                            isValidEmail: (val) => {
                                                const trimmedVal = val.trim();
                                                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

                                                if (!emailRegex.test(trimmedVal)) {
                                                    return "Invalid email address.";
                                                }
                                                return true;
                                            }
                                        }
                                    }}
                                    columnCheck={columnCheck}
                                    errors={errors}
                                />
                            </FormControl>
                        </div>
                    </div>

                    <Divider variant='middle' component="li" />


                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Contact Number
                        </div>
                        <div className="flex flex-row " style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.phoneNumber}>
                                <TextTypeInput
                                    name={'phoneNumber'}
                                    placeholder="0000000000"
                                    control={control}
                                    defaultValue=""
                                    width={'31.6rem'}
                                    height={'2.75rem'}
                                    inputAdornment={true}
                                    inputAdornmentText={'+91'}
                                    rules={{
                                        pattern: {
                                            value: /^[0-9]*$/,
                                            message: 'Invalid Input',
                                        },
                                        validate: {
                                            isValidPhoneNumber: (val) => {
                                                const trimmedVal = val.trim();
                                                const phoneRegex = /^[0-9]{10}$/;
                                                if (trimmedVal && !phoneRegex.test(trimmedVal)) {
                                                    return "Invalid Phone number.";
                                                }
                                                return true;
                                            }
                                        }
                                    }}
                                    errors={errors}
                                />
                            </FormControl>
                        </div>
                    </div>


                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            WhatsApp Number
                        </div>
                        <div className="flex flex-row " style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.whatsAppNumber}>
                                <TextTypeInput
                                    name={'whatsAppNumber'}
                                    placeholder="0000000000"
                                    control={control}
                                    defaultValue=""
                                    width={'31.6rem'}
                                    height={'2.75rem'}
                                    inputAdornment={true}
                                    inputAdornmentText={'+91'}
                                    rules={{
                                        pattern: {
                                            value: /^[0-9]*$/,
                                            message: 'Invalid Input',
                                        },
                                        validate: {
                                            isValidPhoneNumber: (val) => {
                                                const trimmedVal = val.trim();
                                                const phoneRegex = /^[0-9]{10}$/;
                                                if (trimmedVal && !phoneRegex.test(trimmedVal)) {
                                                    return "Invalid phone number.";
                                                }
                                                return true;
                                            }
                                        }
                                    }}
                                    errors={errors}
                                    columnCheck={whatsAppNumberCopy}
                                />
                                <FormGroup>
                                    <FormControlLabel className='text-sm font-light ' control={
                                        <Checkbox
                                            checked={whatsAppNumberCopy}
                                            onChange={(e) => { handleCopyContactNumber(e) }}
                                            sx={checkBoxCustomStyle}
                                        />}
                                        label={<Typography className='text-sm font-light text-[#70829B]'>Same as contact number?</Typography>}
                                    />
                                </FormGroup>
                            </FormControl>

                        </div>
                    </div>


                    <Divider variant='middle' component="li" />


                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Access level
                            <p className=' text-mb-red' >*</p>
                        </div>
                        <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.accessLevel} sx={{ m: 1, minWidth: 120 }}>
                                <SelectTypeInput
                                    name={'accessLevel'}
                                    placeholder={'Select access type'}
                                    control={control}
                                    width={'31.6rem'}
                                    height={'2.75rem'}
                                    defaultValue=''
                                    rules={{ required: "Mandatory Information" }}
                                    errors={errors}
                                    options={Access_Level}
                                />
                            </FormControl>
                        </div>
                    </div>


                    <Divider variant='middle' component="li" />
                    <input type="hidden" {...register('selectedServices', { required: "Mandatory Information" })} />
                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Services
                            <p className=' text-mb-red' >*</p>
                        </div>
                        <div className="flex flex-col" style={{ gap: '1.5rem' }}>
                            <FormControl error={!!errors.selectedServices}>
                            <Box className='gap-x-32' sx={{ display: 'flex', flexDirection: 'row', ml: 3 }}>
                                <Controller
                                    name="selectOPDActive"
                                    control={control}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            label="InClinic"
                                            control=
                                            {<Checkbox {...field} 
                                            checked={field.value ? true : false} 
                                            onChange={(e)=>{toogleServiceChangeOFC(e,FORM_NAMES_KEY.OPD_ACTIVE)}}
                                            sx={checkBoxWithBlueBorder} />}
                                        />
                                    )}
                                />
                                <Controller
                                    name="selectLabsActive"
                                    control={control}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            label="Labs"
                                            control={
                                            <Checkbox 
                                            {...field} 
                                            checked={field.value ? true : false} 
                                            onChange={(e)=>{toogleServiceChangeLabs(e,FORM_NAMES_KEY.LABS_ACTIVE)}}
                                            sx={checkBoxWithBlueBorder} />
                                        }
                                        />
                                    )}
                                />
                                <Controller
                                    name="selectVisionActive"
                                    control={control}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            label="Vision"
                                            control={
                                            <Checkbox 
                                            {...field} 
                                            checked={field.value ? true : false} 
                                            onChange={(e)=>{toogleServiceChangeVision(e,FORM_NAMES_KEY.VISION_ACTIVE)}}
                                            sx={checkBoxWithBlueBorder} />
                                        }
                                        />
                                    )}
                                />
                            </Box>
                            {errors.selectedServices && <FormHelperText>{errors.selectedServices.message}</FormHelperText>}
                            </FormControl>
                        </div>
                    </div>

                    {(watchLabActive || watchOPDActive) && <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', }}>
                            Select Specialty
                            <p className=' text-mb-red' >*</p>
                        </div>
                        <div className="flex flex-col" style={{ gap: '2rem' }}>

                            {watchOPDActive && <div className="flex flex-col">
                                <p className="m-2"> Inclinic </p>
                                <FormControl error={!!errors.OFCspecicality} sx={{ m: 1, minWidth: 120 }}>
                                    <MultipleSelectTypeInput
                                        name={'OFCspecicality'}
                                        placeholder={'Select at least one Department from the list'}
                                        control={control}
                                        width={'38rem'}
                                        height={'2.75rem'}
                                        defaultValue=''
                                        errors={errors}
                                        selectArray={OFCDepartment}
                                        setValues={setOFCselectedDepartment}
                                        getValues={OFCselectedDepartment}
                                        rules={{
                                            required: "Mandatory Information",
                                            validate: (val) => {
                                                const getAccessLevel = getValues('accessLevel')
                                                if(!getAccessLevel){
                                                    return 'Please select Access level first'
                                                }
                                            }
                                        }}
                                    />
                                </FormControl>
                            </div>}

                            {watchLabActive && <div className="flex flex-col">
                                <p className="m-2"> Labs </p>
                                <FormControl error={!!errors.labsSpecicality} sx={{ m: 1, minWidth: 120 }}>
                                    <MultipleSelectTypeInput
                                        name={'labsSpecicality'}
                                        placeholder={'Select at least one Department from the list'}
                                        control={control}
                                        width={'31.6rem'}
                                        height={'2.75rem'}
                                        defaultValue=''
                                        errors={errors}
                                        selectArray={labDepartment}
                                        setValues={setLabSelectedDepartment}
                                        getValues={labSelectedDepartment}
                                        rules={{
                                            required: "Mandatory Information",
                                            validate: (val) => {
                                                const getAccessLevel = getValues('accessLevel')
                                                if(!getAccessLevel){
                                                    return 'Please select Access level first'
                                                }
                                            }
                                        }}
                                    />
                                </FormControl>
                            </div>}
                        </div>
                    </div>}

                    <Divider variant='middle' component="li" />

                    <div className="flex gap-x-32 p-4" style={{ gap: '5rem' }}>
                        <div className="flex text-base font-semibold text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-end', textAlign: 'right' }}>
                            Do you want to receive updates?
                            <p className=' text-mb-red' >*</p>
                        </div>
                        <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                        <FormControl error={!!errors.commsSelection} sx={{ m: 1, minWidth: 120 }}>
                        <input type="hidden" {...register('commsSelection', { required: "Mandatory Information" })} />
                            <CommsSelectCheckBox setValue={setValue} getValue={getValues} watch={watch} SPOCComms={commsOptionsSPOC} DoctorComms={commsOptionsDoctor} AppointmentsComms={commsOptionsOrder} setDoctorComms={setCommsOptionsDoctor} setSPOCComms={setCommsOptionsSPOC} setAppointmentsComms={setCommsOptionsOrder} setCommsPrefEnabled={setCommsPrefEnabled} setCommsPrefChanged={setCommsPrefChanged} />
                            {errors.commsSelection && <FormHelperText>{errors.commsSelection.message}</FormHelperText>}
                            </FormControl>
                        </div>
                    </div>

                    <Divider variant='fullWidth' />
                    <div className="flex flex-row justify-end gap-2 px-4 py-6 text-sm font-semibold bg-[#F5F7F8] ">
                        <button className="flex flex-col justify-center border rounded-lg px-6 py-2 border-[#DBE0E6] font-semibold "
                            onClick={(e) => { e.preventDefault(); handleClose(); }}>
                            Close
                        </button>
                        <button
                            className={`${isValid && isDirty ? ' border-blue-700 text-white bg-blue-600 ' : ' bg-[#F5F7F8] border-[#DBE0E6] '} "flex flex-col justify-center py-2 px-4 border rounded-lg "`}
                            style={{ color: isValid && isDirty   ? 'white' : '#A4B0C0' }}
                            disabled={(isDirty ) ? false : true}
                            onClick={handleSubmit(submitAndProceed)}>
                            {'Submit'}
                        </button>
                    </div>
                </div>
            </List>
        </>

    );
}


